
    <form (ngSubmit)="savePost()" [formGroup]="form">
        <div class="row form-section" id="postForm{{id}}">
            <div class="col">
                <div class="card">
                    <div class="card-title">
                        <h5 class="fa fa-building">
                          {{ this.title }}
                        </h5>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>
                    </div>

                    <div class="card-form">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2 control-label" for="Name">Name </label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="Name" 
                                    name="Name" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="6" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="NameCtrl.invalid && (NameCtrl.dirty || NameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="NameCtrl.errors.required">
                              <span>Name is required.</span>
                           </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2" for="Order">Order </label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="Order" 
                                name="Order" type="text" 
                                required
                                class="form-control" 
                                tabindex="7" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="OrderCtrl.invalid && (OrderCtrl.dirty || OrderCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="OrderCtrl.errors.required">
                                <span>Order is required.</span>
                            </div>
                        </div>
                            
                        <div class="form-row">
                            <label class="col-sm-2">Post Style </label>                                    
                            <div class="form-group col-sm-4">
                                <select formControlName="Style" name="Style" (change)="toggleSection()"
                                    class="form-control" >
                                    <option id="1" value="1">Text</option>
                                    <option id="2" value="2">Training</option>
                                    <option id="3" value="3">FAQ</option>
                                    <option id="4" value="4">Resource or Forms</option>
                                    <option id="5" value="5">Overview</option>
                                </select>
                            </div>
                        </div>    

                        <!-- Training Style -->
                        <div id="training{{id}}" class="mt-1 form-row collapse" [ngClass]="form.value.Style === 2 ? 'show': null">
                            <label class="col-sm-2 control-label">Training Materials</label>
                            <div class="card col d-flex pl-3" style="margin-left: 5px !important;">
                                <div class="user-heading-sec">
                                    <div class="d-inline-block float-left">
                                            <a data-toggle="collapse" href="#newTrainRow-{{this.id}}" 
                                                class="fa fa-address-book btn btn-default "
                                                style="text-transform: none !important;"
                                                >
                                                Add Training
                                            </a>                        
                                    </div>       
                                </div>
                        
                                <table id="trainTable{{id}}" class="table-md mt-1">
                                    <thead>
                                        <tr>
                                            <th scope="col">Title</th>
                                            <th scope="col">Overview</th>
                                            <th scope="col">Link</th>
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        <ng-container *ngFor="let train of trainTable">
                                            <tr id="train-row-{{id}}-{{train.id}}" class="mb-3">
                                                <td class="pr-1 pb-1">
                                                    <input id="title-{{id}}-{{train.id}}" class="form-control"
                                                        value="{{ train.title }}" (change)="updateTrain(train.id)">
                                                </td>

                                                <td class="pr-1">
                                                    <textarea id="overview-{{id}}-{{train.id}}" (change)="updateTrain(train.id)"
                                                            class="form-control" value="{{ train.overview }}">
                                                    </textarea>
                                                </td>

                                                <td class="pr-1">
                                                    <input id="link-{{id}}-{{train.id}}" class="form-control"
                                                        value="{{ train.link }}" (change)="updateTrain(train.id)">
                                                </td>

                                                <td class="pb-1">
                                                    <div class="d-inline-block">
                                                        <a id="del-train{{train.id}}" title="Remove" class="btn fa fa-times"
                                                        (click)="deleteTrain(train.id)"> </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        
                                        <tr class="mt-4" id="newTrainRow-{{id}}" class="collapse">

                                            <td class="pr-1 pb-1" >
                                                <input id="newTrainTitle-{{id}}" (change)="checkForTrainAutoSave()"  
                                                        class="form-control new-state"/>
                                            </td>
                                            
                                            <td class="pr-1">
                                                <textarea id="newTrainOverview-{{id}}" (change)="checkForTrainAutoSave()"  
                                                        class="form-control new-state" value=""></textarea>
                                            </td>

                                            <td class="pr-1" >
                                                <input id="newTrainLink-{{id}}" (change)="checkForTrainAutoSave()"  
                                                        class="form-control new-state"/>
                                            </td>

                                            <td class="pb-1">
                                                <div class="d-inline-block">
                                                    <a title="Cancel" class="btn fa fa-times" (click)="clearTrain()"> </a>
                                                </div>
                                            </td>
                    
                                        </tr>
                                    </tbody>       
                                </table>

                            </div>
                            
                        </div>

                        <!-- FAQ style -->
                        <div id="faq{{id}}" class="mt-1 form-row collapse" [ngClass]="form.value.Style === 3 ? 'show': null">
                            <label class="col-sm-2 control-label">FAQ's</label>
                            <div class="card col d-flex pl-3" style="margin-left: 5px !important;">
                                <div class="user-heading-sec">
                                    <div class="d-inline-block float-left">
                                            <a data-toggle="collapse" href="#newFAQRow-{{this.id}}" 
                                               class="fa fa-address-book btn btn-default "
                                               style="text-transform: none !important;"
                                               >
                                                Add FAQ
                                            </a>                        
                                    </div>       
                                </div>
                        
                                <table id="faqTable{{id}}" class="table-md mt-1">
                                    <thead>
                                        <tr>
                                            <th scope="col">Question</th>
                                            <th scope="col">Answer</th>
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        <ng-container *ngFor="let faq of faqTable">
                                            <tr id="faq-row-{{id}}-{{faq.id}}" class="mb-3">
                                              <td class="pr-1 pb-1">
                                                  <input id="question-{{id}}-{{faq.id}}" class="form-control"
                                                      value="{{ faq.question }}" (change)="updateFAQ(faq.id)">
                                              </td>
          

                                              <td class="pr-1">
                                                <textarea id="answer-{{id}}-{{faq.id}}" (change)="updateFAQ(faq.id)"
                                                       class="form-control" value="{{ faq.answer }}">
                                                </textarea>
                                              </td>

                                              <td class="pb-1">
                                                  <div class="d-inline-block">
                                                      <a id="del-faq{{faq.id}}" title="Remove" class="btn fa fa-times"
                                                      (click)="deleteFAQ(faq.id)"> </a>
                                                  </div>
                                              </td>
                                            </tr>
                                        </ng-container>
                                        
                                        <tr class="mt-4" id="newFAQRow-{{id}}" class="collapse">

                                            <td class="pr-1" >
                                                <input id="newFAQQuestion-{{id}}" (change)="checkForFAQAutoSave()"  
                                                       class="form-control new-state"/>
                                            </td>
                                            
                                            <td class="pr-1">
                                                <textarea id="newFAQAnswer-{{id}}" (change)="checkForFAQAutoSave()"  
                                                       class="form-control new-state" value=""></textarea>
                                            </td>
                                            <td class="">
                                                <div class="d-inline-block">
                                                    <a title="Cancel" class="btn fa fa-times" (click)="clearFAQ()"> </a>
                                                </div>
                                            </td>
                    
                                        </tr>
                                    </tbody>       
                                </table>

                            </div>
                        </div>

                        <!-- Overview Style -->
                        <div id="overview{{id}}" class="mt-1 collapse" [ngClass]="form.value.Style === 5 ? 'show': null">
                            <div id="overviewdoc-{{id}}" class="collape form-row">
                                 <label class="col-sm-2">Most Used Docs </label>
                                 <div class="form-group col-sm-6 doc-list" style="margin-left: 5px !important;">
                                    <div id="overdoc-{{id}}-{{doc.id}}" (click)="deleteOverDoc(doc.id)" class="doc-cell" *ngFor="let doc of overview">
                                        {{doc.name}}
                                    </div>

                                    <select class="doc-new-cell" id="newOverDoc-{{this.id}}" (change)="saveOverDoc()">
                                        <option value="0">Select document</option>
                                        <option *ngFor="let doc of documents" value="{{doc.ID}}">{{doc.Name}}</option>
                                    </select>
                                </div>                             
                                <div class="col-sm-2">
                                    Only the first 4 will be displayed
                                </div>
                             </div>

                        </div>

                        <!-- Resources and Forms style -->
                        <div id="section{{id}}" class="mt-1 collapse" [ngClass]="form.value.Style === 4 ? 'show' : null" >
                            <div class="form-row">
                                <label class="col-sm-2 control-label">Resource & Forms & Checklists</label>
                            </div>
                            <div class="form-row card col d-flex pl-3" style="margin-left: 5px !important;">
                                <div class="user-heading-sec">
                                    <div class="d-inline-block float-left">
                                            <a data-toggle="collapse" href="#newSectionRow-{{this.id}}" 
                                            class="fa fa-address-book btn btn-default "
                                            style="text-transform: none !important;"
                                            >
                                                Add Section
                                            </a>                        
                                    </div>       
                        
                                </div>
                    
                                <table id="sectionTable{{id}}" class="table-md mt-1">
                                    <thead>
                                        <tr>
                                            <th scope="col">Title</th>
                                            <th scope="col">Style</th>
                                            <th scope="col" style="max-width:250px;">Documents</th>
                                            <th scope="col">Collapse</th>
                                            <th scope="col">Remove</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        <ng-container *ngFor="let section of sectionTable">
                                            <tr id="section-row-{{id}}-{{section.id}}" class="mb-3">
                                              <td class="pr-1 pb-1">
                                                  <input id="title-{{id}}-{{section.id}}" class="form-control"
                                                      value="{{ section.title }}" (change)="updateSection(section.id)"/>
                                              </td>
          

                                              <td class="pr-1">
                                                <select class="doc-cell" id="style-{{id}}-{{section.id}}" (change)="updateSection(section.id)"
                                                    class="form-control">
                                                    <option value="1" [attr.selected]="section.style==1 ? true : null">Resource (red white)</option>
                                                    <option value="2" [attr.selected]="section.style==2 ? true : null">Forms (grey blue)</option>
                                                </select>
                                              </td>

                                              <td class="pb-1">
                                                <div id="documents-{{id}}-{{section.id}}" class="collape">
                                                    <div class="card col d-flex pl-3" style="margin-left: 5px !important;">
                                                        <div class="col-sm2" >
                                                            <div id="doc-{{id}}-{{section.id}}-{{doc.id}}" (click)="deleteDoc(section.id, doc.id)" class="doc-cell" 
                                                                *ngFor="let doc of section.docs">
                                                                {{doc.name}}
                                                            </div>                                                       
                                                        </div>
                                                        <div>
                                                            <select class="doc-new-cell" id="newDoc-{{this.id}}-{{section.id}}" (change)="saveDoc(section.id)">
                                                                <option value="0">Select document</option>
                                                                <option *ngFor="let doc of documents" value="{{doc.ID}}">{{doc.Name}}</option>
                                                            </select>
                                                        </div>              
                                                    </div>                             
                                                 </div>
                                              </td>

                                              <td class="pr-1">
                                                <select id="collapse-{{id}}-{{section.id}}" (change)="updateSection(section.id)"
                                                    class="form-control">
                                                    <option value="1" [attr.selected]="section.collapse=='1' ? true : null">Yes</option>
                                                    <option value="2" [attr.selected]="section.collapse=='2' ? true : null">No</option>
                                                </select>
                                              </td>
                                                        
                                                <td class="pb-1">
                                                    <div class="d-inline-block">
                                                        <a id="del-section{{section.id}}" title="Remove" class="btn fa fa-times"
                                                        (click)="deleteSection(section.id)"> </a>
                                                    </div>
                                                </td>
                                            

                                            </tr>
                                        </ng-container>
                                        
                                        <tr class="mt-4" id="newSectionRow-{{id}}" class="collapse">

                                            <td class="pr-1" >
                                                <input id="newSectionTitle-{{id}}" (change)="checkForAutoSave()"  
                                                       class="form-control new-state"/>
                                            </td>
                                            
                                            <td class="pr-1">
                                                <select id="newSectionStyle-{{id}}"  (change)="checkForAutoSave()"
                                                    class="custom-select new-state ">
                                                    <option value="0">Select style</option>
                                                    <option value="1">Resource (red white)</option>
                                                    <option value="2">Forms (grey blue)</option>
                                                </select>
                                            </td>
                                            <td class="pr-1">
                                                &nbsp;
                                            </td>
                                            <td class="pr-1">
                                                <select id="newSectionCollapse-{{id}}" (change)="checkForAutoSave()"
                                                    class="form-control">
                                                    <option value="1">Yes</option>
                                                    <option value="2" selected >No</option>
                                                </select>
                                              </td>

                                            <td class="">
                                                <div class="d-inline-block">
                                                    <a title="Cancel" class="btn fa fa-times" (click)="clearSection()"> </a>
                                                </div>
                                            </td>
                    
                                        </tr>
                                    </tbody>       
                                </table>

          

                            </div>
                        </div>



                        <div class="form-row">
                            <label class="col-sm-2">Body</label>                                    
                            <div class="form-group col-sm-12">
                                <!-- [froalaEditor]="options"  -->
                                <div id="post{{id}}"
                                    class=""
                                    tabindex="9"
                                    [froalaEditor]="options"
                                    [(froalaModel)]="postContent"
                                    >
                                </div>
                            </div>
                            
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </form>

